export default __webpack_public_path__ + "static/media/pac-man-thriller.fa8e85eb.gif";